import { render, staticRenderFns } from "./subFrom.vue?vue&type=template&id=60c4f83c"
import script from "./subFrom.vue?vue&type=script&lang=js"
export * from "./subFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports